import { css } from '@emotion/react';

/** Emits CSS custom properties on :root so Tailwind @theme tokens and
 *  static CSS can reference dynamic theme colors via var(--app-*). */
export default $ => css`
  :root {
    --app-primary: ${$.primaryMain};
    --app-secondary: ${$.secondaryMain};
    --app-success: ${$.successMain};
    --app-danger: ${$.dangerMain};
    --app-warning: ${$.warningMain};
    --app-info: ${$.infoMain};
    --app-border-radius: ${$.borderRadius};

    /* Legacy aliases preserved for existing emotion selectors */
    --primary: ${$.primaryMain};
    --secondary: ${$.secondaryMain};
    --success: ${$.successMain};
    --danger: ${$.dangerMain};
    --warning: ${$.warningMain};
    --info: ${$.infoMain};

    --white: ${$.white};
    --black: ${$.black};

    --gray-100: ${$.gray100};
    --gray-200: ${$.gray200};
    --gray-300: ${$.gray300};
    --gray-400: ${$.gray400};
    --gray-500: ${$.gray500};
    --gray-600: ${$.gray600};
    --gray-700: ${$.gray700};
    --gray-800: ${$.gray800};
    --gray-900: ${$.gray900};

    --navbar-height: ${$.navbarHeight};
  }
`;
